// extracted by mini-css-extract-plugin
export default {"root":"dDVYeqyqzfQgO2Bg_BKG"};